var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesRequiredFields(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 64,
    viewBox: "0 0 528 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.246 5.76V7.048H5.082V15H3.584V7.048H0.42V5.76H8.246ZM10.3809 6.824C10.0542 6.824 9.80222 6.74467 9.62489 6.586C9.45689 6.418 9.37289 6.18467 9.37289 5.886C9.37289 5.58733 9.45689 5.35867 9.62489 5.2C9.80222 5.04133 10.0542 4.962 10.3809 4.962C10.6982 4.962 10.9409 5.04133 11.1089 5.2C11.2862 5.35867 11.3749 5.58733 11.3749 5.886C11.3749 6.18467 11.2862 6.418 11.1089 6.586C10.9409 6.74467 10.6982 6.824 10.3809 6.824ZM11.1229 8V15H9.62489V8H11.1229ZM15.5107 5.942V12.9C15.5107 13.2453 15.5994 13.4973 15.7767 13.656C15.9634 13.8147 16.2107 13.894 16.5187 13.894C16.7707 13.894 16.99 13.8567 17.1767 13.782C17.3634 13.698 17.536 13.586 17.6947 13.446L18.0307 14.538C17.816 14.7247 17.55 14.874 17.2327 14.986C16.9247 15.0887 16.5794 15.14 16.1967 15.14C15.7954 15.14 15.4267 15.0747 15.0907 14.944C14.7547 14.8133 14.4934 14.6033 14.3067 14.314C14.12 14.0153 14.022 13.628 14.0127 13.152V6.362L15.5107 5.942ZM17.9187 8V9.176H12.6687V8H17.9187ZM20.8563 4.85V13.04C20.8563 13.3853 20.9169 13.6233 21.0383 13.754C21.1596 13.8847 21.3603 13.95 21.6403 13.95C21.8083 13.95 21.9483 13.9407 22.0603 13.922C22.1816 13.894 22.3309 13.8473 22.5083 13.782L22.3403 14.902C22.1816 14.9767 21.9996 15.0327 21.7943 15.07C21.5889 15.1167 21.3836 15.14 21.1783 15.14C20.5529 15.14 20.0909 14.9813 19.7923 14.664C19.5029 14.3373 19.3583 13.838 19.3583 13.166V4.85H20.8563ZM26.8416 15.14C26.1416 15.14 25.5256 14.9953 24.9936 14.706C24.4616 14.4167 24.0463 14.0013 23.7476 13.46C23.4583 12.9093 23.3136 12.256 23.3136 11.5C23.3136 10.744 23.4583 10.0953 23.7476 9.554C24.0463 9.00333 24.4569 8.58333 24.9796 8.294C25.5023 8.00467 26.0949 7.86 26.7576 7.86C27.4389 7.86 28.0176 8 28.4936 8.28C28.9696 8.56 29.3336 8.94267 29.5856 9.428C29.8376 9.91333 29.9636 10.464 29.9636 11.08C29.9636 11.248 29.9589 11.4067 29.9496 11.556C29.9403 11.7053 29.9263 11.836 29.9076 11.948H24.2796V10.8H29.2496L28.5076 11.024C28.5076 10.3893 28.3489 9.904 28.0316 9.568C27.7143 9.22267 27.2803 9.05 26.7296 9.05C26.3283 9.05 25.9783 9.14333 25.6796 9.33C25.3809 9.51667 25.1523 9.79667 24.9936 10.17C24.8349 10.534 24.7556 10.982 24.7556 11.514C24.7556 12.0367 24.8396 12.48 25.0076 12.844C25.1756 13.208 25.4136 13.4833 25.7216 13.67C26.0296 13.8567 26.3936 13.95 26.8136 13.95C27.2803 13.95 27.6583 13.8613 27.9476 13.684C28.2369 13.5067 28.4656 13.2593 28.6336 12.942L29.8236 13.502C29.6556 13.838 29.4269 14.132 29.1376 14.384C28.8576 14.6267 28.5216 14.8133 28.1296 14.944C27.7376 15.0747 27.3083 15.14 26.8416 15.14Z",
    fill: "#001B53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.928 5.76C113.591 5.76 114.16 5.87667 114.636 6.11C115.121 6.34333 115.499 6.67467 115.77 7.104C116.041 7.53333 116.176 8.05133 116.176 8.658C116.176 9.25533 116.041 9.77333 115.77 10.212C115.499 10.6413 115.121 10.9727 114.636 11.206C114.16 11.4393 113.591 11.556 112.928 11.556H110.87V15H109.372V5.76H112.928ZM112.69 10.268C113.353 10.268 113.838 10.1327 114.146 9.862C114.463 9.582 114.622 9.18067 114.622 8.658C114.622 8.126 114.463 7.72467 114.146 7.454C113.838 7.174 113.353 7.034 112.69 7.034H110.87V10.268H112.69ZM117.939 15V8H119.213L119.353 9.26C119.54 8.80267 119.815 8.45733 120.179 8.224C120.553 7.98133 121.01 7.86 121.551 7.86C121.691 7.86 121.831 7.874 121.971 7.902C122.111 7.92067 122.228 7.95333 122.321 8L122.111 9.316C122.009 9.27867 121.892 9.25067 121.761 9.232C121.64 9.204 121.472 9.19 121.257 9.19C120.968 9.19 120.683 9.26933 120.403 9.428C120.123 9.57733 119.89 9.806 119.703 10.114C119.526 10.422 119.437 10.814 119.437 11.29V15H117.939ZM124.492 6.824C124.166 6.824 123.914 6.74467 123.736 6.586C123.568 6.418 123.484 6.18467 123.484 5.886C123.484 5.58733 123.568 5.35867 123.736 5.2C123.914 5.04133 124.166 4.962 124.492 4.962C124.81 4.962 125.052 5.04133 125.22 5.2C125.398 5.35867 125.486 5.58733 125.486 5.886C125.486 6.18467 125.398 6.418 125.22 6.586C125.052 6.74467 124.81 6.824 124.492 6.824ZM125.234 8V15H123.736V8H125.234ZM130.602 7.86C131.162 7.86 131.638 7.944 132.03 8.112C132.431 8.27067 132.767 8.49933 133.038 8.798C133.309 9.09667 133.514 9.43733 133.654 9.82L132.24 10.38C132.119 9.95067 131.923 9.624 131.652 9.4C131.391 9.16667 131.045 9.05 130.616 9.05C130.196 9.05 129.837 9.148 129.538 9.344C129.239 9.53067 129.011 9.806 128.852 10.17C128.703 10.534 128.628 10.982 128.628 11.514C128.628 12.0367 128.707 12.48 128.866 12.844C129.025 13.208 129.253 13.4833 129.552 13.67C129.851 13.8567 130.205 13.95 130.616 13.95C130.933 13.95 131.209 13.8987 131.442 13.796C131.675 13.684 131.867 13.53 132.016 13.334C132.175 13.1287 132.282 12.8813 132.338 12.592L133.696 13.054C133.565 13.474 133.36 13.8427 133.08 14.16C132.809 14.468 132.469 14.7107 132.058 14.888C131.647 15.056 131.176 15.14 130.644 15.14C129.953 15.14 129.342 14.9953 128.81 14.706C128.278 14.4167 127.863 14.0013 127.564 13.46C127.275 12.9093 127.13 12.256 127.13 11.5C127.13 10.744 127.275 10.0953 127.564 9.554C127.863 9.00333 128.273 8.58333 128.796 8.294C129.328 8.00467 129.93 7.86 130.602 7.86ZM138.519 15.14C137.819 15.14 137.203 14.9953 136.671 14.706C136.139 14.4167 135.724 14.0013 135.425 13.46C135.136 12.9093 134.991 12.256 134.991 11.5C134.991 10.744 135.136 10.0953 135.425 9.554C135.724 9.00333 136.135 8.58333 136.657 8.294C137.18 8.00467 137.773 7.86 138.435 7.86C139.117 7.86 139.695 8 140.171 8.28C140.647 8.56 141.011 8.94267 141.263 9.428C141.515 9.91333 141.641 10.464 141.641 11.08C141.641 11.248 141.637 11.4067 141.627 11.556C141.618 11.7053 141.604 11.836 141.585 11.948H135.957V10.8H140.927L140.185 11.024C140.185 10.3893 140.027 9.904 139.709 9.568C139.392 9.22267 138.958 9.05 138.407 9.05C138.006 9.05 137.656 9.14333 137.357 9.33C137.059 9.51667 136.83 9.79667 136.671 10.17C136.513 10.534 136.433 10.982 136.433 11.514C136.433 12.0367 136.517 12.48 136.685 12.844C136.853 13.208 137.091 13.4833 137.399 13.67C137.707 13.8567 138.071 13.95 138.491 13.95C138.958 13.95 139.336 13.8613 139.625 13.684C139.915 13.5067 140.143 13.2593 140.311 12.942L141.501 13.502C141.333 13.838 141.105 14.132 140.815 14.384C140.535 14.6267 140.199 14.8133 139.807 14.944C139.415 15.0747 138.986 15.14 138.519 15.14Z",
    fill: "#001B53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    width: 42,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    width: 38,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    width: 80,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 76,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 36,
    width: 74,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 36,
    width: 39,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 36,
    width: 42,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 36,
    width: 80,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 36,
    width: 56,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    width: 56,
    height: 20,
    rx: 5,
    fill: "#EEEFF2"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    width: 1,
    height: 64,
    fill: "#F6F7F9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 528,
    height: 1,
    fill: "#F6F7F9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    width: 1,
    height: 64,
    fill: "#F6F7F9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    width: 1,
    height: 64,
    fill: "#F6F7F9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    width: 1,
    height: 64,
    fill: "#F6F7F9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 455,
    width: 1,
    height: 64,
    fill: "#F6F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesRequiredFields);
export default __webpack_public_path__ + "static/media/servicesRequiredFields.62a63b30a9da2fed8b9435aa3c7bebd2.svg";
export { ForwardRef as ReactComponent };